import {
	ReservationMailPreviewError,
	ReservationMailPreviewItem,
	ReservationMailPreviewResponse,
} from '@/new-transport/_models/transport-list.model';

export interface SplitReservationMailPreviewResult {
	previews: ReservationMailPreviewResponse[];
	errors: ReservationMailPreviewError[];
}

/**
 * Splits a mixed mail preview API response into successful previews and per-reservation errors.
 *
 * @param items - Mixed array of preview results and error objects from mail_preview.
 * @returns Successful previews and reservation-level errors.
 */
export function splitReservationMailPreview(items: ReservationMailPreviewItem[]): SplitReservationMailPreviewResult {
	const previews: ReservationMailPreviewResponse[] = [];
	const errors: ReservationMailPreviewError[] = [];

	for (const item of items) {
		if (isReservationMailPreviewError(item)) {
			errors.push(item);
		} else {
			previews.push(item);
		}
	}

	return { previews, errors };
}

/**
 * @param item - Single item from mail_preview response.
 * @returns Whether the item represents a reservation-level preview error.
 */
export function isReservationMailPreviewError(item: unknown): item is ReservationMailPreviewError {
	return typeof item === 'object' && item !== null && 'error' in item && 'reservationId' in item;
}
